<glxy-form-field [bottomSpacing]="bottomSpacing">
  <glxy-label>{{ placeholder }}</glxy-label>
  <mat-chip-grid #chipList (click)="openAutocomplete()">
    @for (val of value; track val; let i = $index) {
      @if (getOptionLabelFromValue(val); as optionLabel) {
        <mat-chip-row [disabled]="disabled" [ngStyle]="{ opacity: disabled ? 0.4 : 1 }">
          <div class="value-chip">
            <span>{{ optionLabel }}</span>
            @if (!disabled) {
              <mat-icon class="item-remove-button" (click)="remove(i)">cancel</mat-icon>
            }
          </div>
        </mat-chip-row>
      }
    }
    <input
      placeholder="{{ inputPlaceholder }}"
      matInput
      #searchInput
      class="cursor-pointer chip-input"
      [matChipInputFor]="chipList"
      [attr.maxlength]="customTagLength"
      [required]="required"
      [disabled]="disabled"
      [matAutocomplete]="auto"
      (input)="inputTerm.next(searchInput.value)"
      (click)="openAutocomplete()"
    />
    @if (options) {
      <mat-icon
        matSuffix
        class="cursor-pointer option-select-arrow"
        (click)="openAutocomplete()"
        [ngStyle]="{ color: hasError ? '#c62828' : null }"
      >
        arrow_drop_down
      </mat-icon>
    }
    <mat-autocomplete #auto="matAutocomplete">
      @if (loading && !searchInput.value) {
        <span>
          <mat-option [disabled]="true"></mat-option>
        </span>
      } @else {
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option.value" (onSelectionChange)="add($event)" (onEnter)="add(option)">
            <span>{{ option.name }}</span>
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-chip-grid>

  @if (tooltip && !hasError) {
    <glxy-hint align="left" [matTooltip]="tooltip">
      <a (click)="(null)" class="link">
        {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
      </a>
    </glxy-hint>
  }
  @if (hint) {
    <glxy-hint>
      {{ hint | translate }}
    </glxy-hint>
  }
  @if (maxFields) {
    <glxy-hint align="right">{{ (value || []).length }}/{{ maxFields }}</glxy-hint>
  }
  @if (overMaxFields) {
    <glxy-error>
      {{ 'FRONTEND.FORMS.INPUT.MAX_LENGTH_ERROR' | translate: { maxLength: maxFields } }}
    </glxy-error>
  }
  @if (underMinFields) {
    <glxy-error>
      {{ 'FRONTEND.FORMS.INPUT.REQUIRED' | translate }}
    </glxy-error>
  }
</glxy-form-field>
